import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChartData, GroupedBarChartComponent } from '../../../../_shared';
import { DateFilterComponent } from '../../../../../_shared/components';
import { DateIntervalFilterData } from '../../../../../_shared/models';
import { DateInterval } from '../../../../../_shared/enums';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-fuel-total-decrease-full-modal',
  standalone: true,
  imports: [GroupedBarChartComponent, DateFilterComponent, TranslocoDirective],   //, MultipleBarchart
  templateUrl: './fuel-total-decrease-full-modal.component.html',
  styleUrl: './fuel-total-decrease-full-modal.component.scss'
})
export class FuelTotalDecreaseFullModal {
  // Mock headline figures until the API supplies this summary.
  protected readonly headline = { value: '200ℓ', change: '+19.29%' };
  protected viewMode: 'all' | 'unusual' | 'driving' | 'idling' = 'all';

  public utilizationDateFilter: DateIntervalFilterData;
  public defaultInterval: DateInterval = DateInterval.Day;

  protected totalDecreaseBig = ChartData.totalDecreaseBig;

  protected dataUnusual = [
    { month: 'Jan', 'Unusual Loss': 48 },
    { month: 'Feb', 'Unusual Loss': 30 },
    { month: 'Mar', 'Unusual Loss': 30 },
    { month: 'Apr', 'Unusual Loss': 48 },
    { month: 'May', 'Unusual Loss': 63 },
    { month: 'Jun', 'Unusual Loss': 44 },
    { month: 'Jul', 'Unusual Loss': 35 },
    { month: 'Aug', 'Unusual Loss': 44 },
    { month: 'Sep', 'Unusual Loss': 52 },
    { month: 'Oct', 'Unusual Loss': 29 },
    { month: 'Nov', 'Unusual Loss': 37 },
    { month: 'Dec', 'Unusual Loss': 30 },
  ];
  protected dataDriving = [
    { month: 'Jan', 'Driving': 30 },
    { month: 'Feb', 'Driving': 20 },
    { month: 'Mar', 'Driving': 20 },
    { month: 'Apr', 'Driving': 20 },
    { month: 'May', 'Driving': 20 },
    { month: 'Jun', 'Driving': 53 },
    { month: 'Jul', 'Driving': 18 },
    { month: 'Aug', 'Driving': 55 },
    { month: 'Sep', 'Driving': 19 },
    { month: 'Oct', 'Driving': 20 },
    { month: 'Nov', 'Driving': 19 },
    { month: 'Dec', 'Driving': 19 },
  ];
  protected dataIdling = [
    { month: 'Jan', 'Idling Consumption': 8 },
    { month: 'Feb', 'Idling Consumption': 3 },
    { month: 'Mar', 'Idling Consumption': 4 },
    { month: 'Apr', 'Idling Consumption': 6 },
    { month: 'May', 'Idling Consumption': 5 },
    { month: 'Jun', 'Idling Consumption': 2 },
    { month: 'Jul', 'Idling Consumption': 3 },
    { month: 'Aug', 'Idling Consumption': 2 },
    { month: 'Sep', 'Idling Consumption': 3 },
    { month: 'Oct', 'Idling Consumption': 3 },
    { month: 'Nov', 'Idling Consumption': 5 },
    { month: 'Dec', 'Idling Consumption': 2 },
  ];

  constructor(private modalRef: NgbActiveModal) {
    this.utilizationDateFilter = {} as DateIntervalFilterData;
  }

  onUtilizationDateFilterChange(filter: DateIntervalFilterData): void {
    this.utilizationDateFilter = filter;
  }

  protected buttonMenuClick(event: MouseEvent): void {
    event.stopPropagation();
  }

  protected closeModal(): void {
    this.modalRef.close();
  }
}
